import React from 'react';
import { ErrorContainer } from '../StyledComponents/Div';
import { useNavigate } from 'react-router-dom';

const ErrorView = () => {
  const navigate = useNavigate();
  return (
    <ErrorContainer>
      <h1>Error</h1>
      <p>
        Oops! Well, this is embarrassing - something went wrong. Please{' '}
        <button onClick={() => navigate(-1)} type="button">
          Go back
        </button>{' '}
        to the previous page. If this continues to happen, please contact{' '}
        <a href="mailto:helpdesk@dallasmarketcenter.com">Help Desk</a>.
      </p>
    </ErrorContainer>
  );
};

export default ErrorView;
